module.exports = __webpack_public_path__ + "static/media/Quicksand-Bold.96e2106e.ttf";